import React, { useState, createContext } from 'react';

interface InputInterface {input? : string, setInput? : React.Dispatch<React.SetStateAction<string>>}
export const InputContext = createContext<InputInterface>({});